import FeatureGates from '@atlaskit/feature-gate-js-client';

import { CONVERSATION_LIST_PAGINATION_EXPERIMENT } from './constants';

export const isConversationListPaginationEnabled = ({
	fireExperimentExposure = true,
}: { fireExperimentExposure?: boolean } = {}): boolean => {
	if (fireExperimentExposure) {
		return FeatureGates.getExperimentValue(
			CONVERSATION_LIST_PAGINATION_EXPERIMENT,
			'isEnabled',
			false,
		);
	}

	return FeatureGates.getExperimentValue(
		CONVERSATION_LIST_PAGINATION_EXPERIMENT,
		'isEnabled',
		false,
		{ fireExperimentExposure: false },
	);
};
